import { useState } from "react";
import { Alert, Button, ListGroup, Modal, Navbar } from "react-bootstrap";
import { EnvelopePaper } from "react-bootstrap-icons";
import { smpwAPI } from "../../api/smpw";
import { SMPWInvite } from "../../types/smpw";
import { ShowStatus, Status } from "../scheduling/common";
import { sleep } from "../../helpers/util";
import { useQueryClient } from "@tanstack/react-query";
import { deleteFromSMPWInviteCache } from "../../query/smpw";
import { useTranslation } from "react-i18next";
import HourglassGlobals from "../../helpers/globals";

export function HaveSMPWInvite() {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);

  return (
    <>
      <SMPWInviteModal show={show} setShow={setShow} invites={HourglassGlobals.smpwInvites} />
      <Navbar
        variant="info"
        className="bg-info ps-2 cursor-pointer"
        onClick={() => setShow(true)}
        hidden={!HourglassGlobals.smpwInvites.length}
      >
        <div className="text-center w-100">
          <EnvelopePaper className="me-1" />
          {t("smpw.invite_message")}
        </div>
      </Navbar>
    </>
  );
}

function SMPWInviteModal(props: { show: boolean; setShow: (set: boolean) => void; invites: SMPWInvite[] }) {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const [status, setStatus] = useState(Status.Null);
  const handleClose = () => {
    setStatus(Status.Null);
    props.setShow(false);
  };

  const handleResponse = async (invite: SMPWInvite, response: boolean) => {
    try {
      setStatus(Status.Pending);
      await smpwAPI.respondToMyInvite({ ...invite, accepted: response });
      setStatus(Status.Success);
      deleteFromSMPWInviteCache(queryClient, invite);
      if (response) {
        window.location.replace(window.location.href);
      }
      await sleep(500);
      handleClose();
    } catch {
      setStatus(Status.Failure);
    }
  };

  return (
    <Modal show={props.show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{t("smpw.invitations")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Alert>
          <p className="mb-0">
            <b>{t("smpw.note")}:</b> <span className="fw-lighter">{t("smpw.invite_privacy_notice")}</span>
          </p>
          <ul className="mb-0">
            <li>{t("general.name")}</li>
            <li>{t("smpw.cell_number")}</li>
            <li>{t("smpw.email_address")}</li>
          </ul>
        </Alert>
        <ListGroup>
          {props.invites.map((i) => {
            return (
              <ListGroup.Item key={i.id} className="d-flex justify-content-between">
                <Button size="sm" variant="success" onClick={() => handleResponse(i, true)}>
                  {t("general.accept")}
                </Button>
                {i.zone_name}
                <Button size="sm" variant="danger" onClick={() => handleResponse(i, false)}>
                  {t("general.decline")}
                </Button>
              </ListGroup.Item>
            );
          })}
        </ListGroup>
      </Modal.Body>
      <Modal.Footer>
        <ShowStatus status={status} />
      </Modal.Footer>
    </Modal>
  );
}
